const color = {
  dark: "#353F4A",
  primary: "#1E65A9",
  secondary: "#333333",
  background: "#1E65A9",
  paper: "#F6F7FB"
}

export default color
